import { Dialog, DialogContent, DialogClose, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import ChallengeVideoPlayer from "@/components/challenge/ChallengeVideoPlayer";
import type { PopupCampaign } from "@/services/popupService";

interface EntryPopupModalProps {
  campaign: PopupCampaign;
  open: boolean;
  onClose: () => void;
  onCtaClick: () => void;
}

const EntryPopupModal = ({ campaign, open, onClose, onCtaClick }: EntryPopupModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        position="center"
        dir="rtl"
        className="max-w-[calc(100vw-2rem)] sm:max-w-md p-0 max-h-[85vh] overflow-y-auto rounded-2xl"
      >
        {/* Radix a11y: exactly one DialogTitle. Use the heading when present, else a hidden fallback. */}
        {!campaign.heading && (
          <DialogTitle className="sr-only">{campaign.title || "הודעה"}</DialogTitle>
        )}
        <DialogDescription className="sr-only">
          {campaign.body_text || campaign.heading || campaign.title || ""}
        </DialogDescription>

        {/* Pinned close affordance — survives the scroll container and sits over the image. */}
        <DialogClose asChild>
          <Button
            variant="ghost"
            size="icon"
            aria-label="סגירה"
            className="absolute end-2 top-2 z-10 h-9 w-9 rounded-full bg-background/70 backdrop-blur-sm hover:bg-background"
          >
            <X className="h-5 w-5" />
          </Button>
        </DialogClose>

        <div className="flex flex-col">
          {campaign.image_url && (
            <img
              src={campaign.image_url}
              alt={campaign.heading || campaign.title || ""}
              className="max-h-[40vh] w-full object-cover"
            />
          )}
          <div className="flex flex-col gap-3 p-5 text-start">
            {campaign.heading && (
              <DialogTitle className="text-xl font-bold">{campaign.heading}</DialogTitle>
            )}
            {campaign.body_text && (
              <p className="whitespace-pre-line text-base leading-relaxed text-foreground/80">{campaign.body_text}</p>
            )}
            {campaign.video_url && (
              <div className="overflow-hidden rounded-lg">
                <ChallengeVideoPlayer videoUrl={campaign.video_url} />
              </div>
            )}
            {campaign.cta_label && (
              <Button className="mt-1 w-full" onClick={onCtaClick}>
                {campaign.cta_label}
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EntryPopupModal;
